import { useDispatch } from 'react-redux';
import { twMerge } from 'tailwind-merge';

import { useMenuVisibility } from 'contexts/MenuVisibilityContext';

import { setShowSelectModal } from 'actions/global-actions';

import Button, { ButtonSize } from '../buttons/Button';

const FreeRMVControl = ({
  size,
  className,
  variant = 'default',
}: {
  size?: ButtonSize;
  className?: string;
  variant?: 'default' | 'referral';
}) => {
  const dispatch = useDispatch();
  const { setHamburgerMenuVisible } = useMenuVisibility();

  const handleClick = () => {
    setHamburgerMenuVisible(false);
    dispatch(setShowSelectModal(true));
  };

  return (
    <Button
      twClassName={twMerge(
        'tw-text-white tw-border-none min-[1650px]:tw-min-w-[128px] min-[1650px]:tw-w-[132px] tw-min-w-[147px]',
        variant === 'referral' ? 'tw-bg-[#2D5EFF]' : 'tw-bg-greenGradient',
        className
      )}
      color="green"
      text="Free RMV"
      size={size ?? 'medium'}
      onClick={handleClick}
    />
  );
};

export default FreeRMVControl;
